import { render, staticRenderFns } from "./SlideFormDetail.vue?vue&type=template&id=41f82548&scoped=true"
import script from "./SlideFormDetail.vue?vue&type=script&lang=js"
export * from "./SlideFormDetail.vue?vue&type=script&lang=js"
import style0 from "./SlideFormDetail.vue?vue&type=style&index=0&id=41f82548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f82548",
  null
  
)

export default component.exports